"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMintNewEditionFromMasterEditionViaTokenInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const MintNewEditionFromMasterEditionViaTokenArgs_1 = require("../types/MintNewEditionFromMasterEditionViaTokenArgs");
const MintNewEditionFromMasterEditionViaTokenStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    [
        'mintNewEditionFromMasterEditionViaTokenArgs',
        MintNewEditionFromMasterEditionViaTokenArgs_1.mintNewEditionFromMasterEditionViaTokenArgsBeet,
    ],
], 'MintNewEditionFromMasterEditionViaTokenInstructionArgs');
const mintNewEditionFromMasterEditionViaTokenInstructionDiscriminator = 11;
function createMintNewEditionFromMasterEditionViaTokenInstruction(accounts, args) {
    const { newMetadata, newEdition, masterEdition, newMint, editionMarkPda, newMintAuthority, payer, tokenAccountOwner, tokenAccount, newMetadataUpdateAuthority, metadata, } = accounts;
    const [data] = MintNewEditionFromMasterEditionViaTokenStruct.serialize({
        instructionDiscriminator: mintNewEditionFromMasterEditionViaTokenInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: newMetadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: newEdition,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: masterEdition,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: newMint,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: editionMarkPda,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: newMintAuthority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: payer,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: tokenAccountOwner,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: tokenAccount,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: newMetadataUpdateAuthority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: metadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s'),
        keys,
        data,
    });
    return ix;
}
exports.createMintNewEditionFromMasterEditionViaTokenInstruction = createMintNewEditionFromMasterEditionViaTokenInstruction;
//# sourceMappingURL=MintNewEditionFromMasterEditionViaToken.js.map